import React, { useEffect } from 'react';
import queryString from 'query-string';

import { WithLocalize } from '../../containers/I18nProvider';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import LoginForm from './LoginForm';
import './style.scss';

const Login = ({ translate, location }) => {
  const api = new ServiceApi();
  const parameters = queryString.parse(location?.search);

  const validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    document.body.className = 'fibercom-oauth-body';
    document.title = 'Fibercom';
  }, []);

  return (
    <div className="fibercom-oauth">
      {validateParams() ? (
        <LoginForm api={api} location={location} />
      ) : (
        <RequestLoginErrorMessage
          onlyMessage={true}
          message={translate('RequestLoginErrorMessage')}
        />
      )}
    </div>
  );
};

export default WithLocalize(Login);
